export const ON_LEFT = "ON_LEFT";
export const ON_RIGHT = "ON_RIGHT";
export const ON_UP = "ON_UP";
export const ON_DOWN = "ON_DOWN";

export const SET_CURRENT_PAGE = "SET_CURRENT_PAGE";
export const SET_ACTIVE = "SET_ACTIVE";
export const SET_LAST_SLIDER_CHILD = "SET_LAST_SLIDER_CHILD";
export const REGISTER_CONTROL = "REGISTER_CONTROL";
export const UPDATE_CONTROL = "UPDATE_CONTROL";

export const ON_TEST = "ON_TEST";
export const SAVE_ALL_CARDS = "SAVE_ALL_CARDS";
export const SAVE_ALL_CARDS_HTML = "SAVE_ALL_CARDS_HTML";
export const ON_CARD_FLIP = "ON_CARD_FLIP";
export const SAVE_CARD_STYLE = "SAVE_CARD_STYLE";

export const SET_GAME_INTRO = "ON_GAME_INTRO";
export const SET_GAME_SCORE = "SET_GAME_SCORE";
export const SET_GAME_LIVES = "SET_GAME_LIVES";

export const UNFLIP_OLD_CARDS = "UNFLIP_OLD_CARDS";
